import axios from "../plugins/parseAxios";

export class AreaBookingAPI {
  static createAreaBooking(formData) {
    return axios.post("functions/createAreaBooking", formData);
  }
  static editAreaBooking(formData) {
    return axios.post("functions/editAreaBooking", formData);
  }
  static checkInAreaBooking(formData) {
    return axios.post("functions/checkInAreaBooking", formData);
  }
  static checkOutAreaBooking(formData) {
    return axios.post("functions/checkOutAreaBooking", formData);
  }
  static cancelAreaBooking(areaBookingId) {
    return axios.post("functions/cancelAreaBooking", {
      id: areaBookingId
    });
  }
  static getAreaBookingByBooking(bookingId) {
    return axios.post("functions/getAreaBookingByBooking", {
      bookingId
    });
  }
  static getAreaBookingBetweenDate(formData) {
    return axios.post("functions/getAreaBookingBetweenDate", formData)
  }
  static getAreaBookingByArea(areaId) {
    return axios.post("functions/getAreaBookingByBooking", {
      areaId
    })
  };
  static getAreaBookingCheckedInDateBetweenDate(formData) {
    return axios.post("functions/getAreaBookingCheckedInDateBetweenDate", formData)
  }
  static getCheckinAreaBookingByAreas(formData) {
    return axios.post("functions/getCheckinAreaBookingByAreas", formData)
  }
}